module.exports = "/images/senna.jpg?6898e9438f84ebaf00a38309982988db";